import { X, Check, AlertCircle } from 'lucide-react';
import { useToast, type Toast as ToastType } from '../../contexts/ToastContext';
import clsx from 'clsx';

function ToastItem({ toast }: { toast: ToastType }) {
  const { dismissToast } = useToast();

  return (
    <div
      className={clsx(
        'flex items-center gap-3 px-4 py-3 rounded-lg border backdrop-blur-sm shadow-lg',
        'animate-in slide-in-from-right-5 fade-in duration-200',
        toast.type === 'success' && 'bg-action/20 border-action/50 text-action-light',
        toast.type === 'error' && 'bg-red-500/20 border-red-500/50 text-red-300'
      )}
    >
      {toast.type === 'success' ? (
        <Check className="w-5 h-5 shrink-0" />
      ) : (
        <AlertCircle className="w-5 h-5 shrink-0" />
      )}
      <span className="text-sm font-medium">{toast.message}</span>
      <button
        onClick={() => dismissToast(toast.id)}
        className="ml-auto p-1 hover:bg-wolf-700/50 rounded transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

export function ToastContainer() {
  const { toasts } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map(toast => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
